let BASE_URL = "";
if (process.env.NODE_ENV === 'production') {
  BASE_URL = "https://maintenance.richglorytech.com.tw/xunjian/public/index.php/";
  // BASE_URL = "http://xunjian.hebeilingyan.com/";
} else {
  BASE_URL = "/admin";
}


module.exports = {
  BaseUrl: BASE_URL,
  upVerison: '/admin/Upload/upVerison',
  uploadFile: '/admin/Upload/uploadFile',
  uploadImage: "/admin/Upload/upload",
  uploadImageMore: "/admin/Upload/uploadMore",
  uploadMoreCos: "/admin/Upload/uploadMoreCos",
  imagePath: "https://maintenance.richglorytech.com.tw/xunjian/public/",
  // imagePath: "http://xunjian.hebeilingyan.com/",
  admin: {
    login: "/admin/login/login", //登入
    captcha: "/admin/login/verifyCode", //验证码
    getAdminList: "/admin/Admin/index", //获取管理员列表
    create: "/admin/Admin/create", //添加管理员
    update: "/admin/Admin/update", //修改管理员
    del: "/admin/Admin/delete", //删除管理员,
    updateStatus: "/admin/Admin/enable", //修改管理员狀態
    resetPassword: "/admin/Admin/resetPassword", //重置密码
    getGroupList: "/admin/Admin/getGroupList", //获取分组
    dump: "/admin/Admin/dump", //获取分组
  },
  //角色
  role: {
    getRoleList: "/admin/Role/index", //获取带分页角色列表
    getAllRoleList: "/admin/Role/getAllRoleList", //获取所有角色列表
    create: "/admin/Role/create", //添加角色
    update: "/admin/Role/update", //修改角色
    del: "/admin/Role/delete", //删除角色
    updateStatus: "/admin/Role/enable", //修改角色狀態
    setRules: "/admin/Role/setRules", //设置角色权限

  },
  //权限
  rules: {
    getRuleList: "/admin/Rule/index", //获取带分页权限列表
    getAllRuleList: "/admin/Rule/getAllRuleList", //获取所有权限（分配权限）
    getRoleRules: "/admin/Rule/getRoleRules", //获取角色拥有的权限
    create: "/admin/Rule/create", //添加权限
    update: "/admin/Rule/update", //修改权限
    del: "/admin/Rule/delete", //删除权限
    updateStatus: "/admin/Rule/updateStatus", //修改权限狀態
    getRulesInfo: "/admin/Rule/getRulesInfo", //获取权限详情
  },
  //测试
  test: {
    testList: "/admin/Test/index", //列表
    create: "/admin/Test/create", //添加
    update: "/admin/Test/update", //修改
    del: "/admin/Test/delete", //删除
    updateStatus: "/admin/Test/enable", //修改狀態
  },
  //文件管理
  file: {
    categoryList: "/admin/File/category", //获取分类
    addCategory: "/admin/File/addCategory", //添加分类
    deleteCategory: "/admin/File/deleteCategory", //删除分类
    imageList: "/admin/File/index", //圖片库
    cosUpload: '/admin/Upload/cosUpload', //圖片上传
    deleteImage: "/admin/Upload/deleteObject", //删除圖片
    move: "/admin/File/do_move", //移动圖片
    gather: "/admin/File/picToCos", //采集
    download: "/admin/File/download", //下载
  },
  //测试
  testcos: {
    testList: "/admin/Testcos/index", //列表
    create: "/admin/Testcos/create", //添加
    update: "/admin/Testcos/update", //修改
    del: "/admin/Testcos/delete", //删除
    updateStatus: "/admin/Testcos/enable", //修改狀態
  },
  //分組管理
  group: {
    gList: "/admin/Group/index", //列表
    create: "/admin/Group/create", //添加
    update: "/admin/Group/update", //修改
    del: "/admin/Group/delete", //删除
    getAdminList: "/admin/Group/getAdminList", //修改狀態
    jiebang: "/admin/Group/jiebang",
  },
  //管理端資料庫
  database: {
    dList: "/admin/Database/index", //列表
    create: "/admin/Database/create", //添加
    update: "/admin/Database/update", //修改
    del: "/admin/Database/delete", //删除
    updateStatus: "/admin/Database/enable", //修改狀態
    dump: "/admin/Database/dump", //到處
    dumpPrint:'/admin/Database/dumpPrint',

  },
  //廠商段資料庫
  databasea: {
    dList: "/admin/Databasea/index", //列表
    create: "/admin/Databasea/create", //添加
    update: "/admin/Databasea/update", //修改
    del: "/admin/Databasea/delete", //删除
    updateStatus: "/admin/Databasea/enable", //修改狀態
    dump: "/admin/Databasea/dump", //到處
    enable:'/admin/Databasea/updateStatus',
    dumpPrint:'/admin/Databasea/dumpPrint',


  },
  record: {
    rList: "/admin/Record/index",
    edit: "/admin/Record/edit",
    dump: "/admin/Record/dump",
    dumpImage: "/admin/Record/dumpImage",
    dumpWord: "/admin/Record/dumpWord",

    groupList: "/admin/Record/groupList",
    import:"/admin/Record/import",
  },
  common: {
    getAdminList: '/admin/Common/getAdminList',
    getGroupList: "/admin/Common/getGroupList", //分組列表
    getGroupListAll: "/admin/Common/getGroupListAll", //分組列表
    detail: '/admin/Common/detail', //巡檢详情
    recordLogByDatabaseId:"/admin/Common/recordLogByDatabaseId", ///由芯片ID查询巡檢记录
    getDatabaseByGroupId:'/admin/Common/getDatabaseByGroupId',
    getDatabase:'/admin/Common/getDatabase',

    delMessage:'/admin/Common/delMessage',
    getUser:"/admin/Common/getUser"
  },
  recordgroup: {
    index: "/admin/Grouprecord/index",
    dump: "/admin/Grouprecord/dump",
    dumpImage: "/admin/Grouprecord/dumpImage",
    dumpword:"/admin/Grouprecord/dumpword",
  },
  version:{
    index:"/admin/Version/index",
    create:'/admin/Version/create',
    delete:'/admin/Version/delete',
    download:'admin/Common/download',
  },

  adminuser:{
    index:'/admin/Adminuser/index',
    create:'/admin/Adminuser/create',
    update:'/admin/Adminuser/update',
    delete:'/admin/Adminuser/delete',
    reset:'/admin/Adminuser/reset',
    typeStatus:'/admin/Adminuser/enable',
  }




}



// WEBPACK FOOTER //
// ./src/common/api.js